/** Class applied to a marker that has unread comments, and to the badge itself. */
const MARKER_UNREAD_CLASS = 'has-unread';
const MARKER_BADGE_CLASS = 'brafton-marker-unread';

/**
 * Paints (or clears) the unread-comment badge on one on-page marker.
 *
 * Markers are plain DOM appended to the HOST page rather than rendered by a template,
 * so their badges are applied imperatively. Kept as a standalone function so the
 * behaviour is testable without booting the widget.
 *
 * @param marker      The marker element.
 * @param unreadCount Unread comments for the current reporter; 0 removes the badge.
 */
export function applyMarkerUnreadBadge(marker: HTMLElement, unreadCount: number): void {
  const existing = marker.querySelector(`.${MARKER_BADGE_CLASS}`);

  if (unreadCount <= 0) {
    marker.classList.remove(MARKER_UNREAD_CLASS);
    existing?.remove();
    return;
  }

  marker.classList.add(MARKER_UNREAD_CLASS);

  // Reuse the existing node so repainting does not churn the DOM on every refresh.
  const badge = existing ?? marker.ownerDocument.createElement('span');
  badge.className = MARKER_BADGE_CLASS;
  badge.textContent = String(unreadCount);
  if (!existing) {
    marker.appendChild(badge);
  }
}
